"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useContainerQuery_1 = __importDefault(require("../../../hooks/useContainerQuery"));
const typography_1 = __importDefault(require("../../typography/typography"));
require("../../../styles/components/grid-layout/line-chart.less");
const BREAKPOINTS = {
    big: { minWidth: 250 },
};
const LineChart = ({ cardComponent }) => {
    const { ref, matches } = (0, useContainerQuery_1.default)(BREAKPOINTS);
    return (react_1.default.createElement("div", { ref: ref, className: "card-content-header line-chart" },
        react_1.default.createElement("div", { className: "line-chart-content" },
            react_1.default.createElement(typography_1.default, { variant: "subtitle1", className: "display-name" }, "Line Chart"),
            react_1.default.createElement(typography_1.default, { variant: "body1", className: "display-name" },
                matches.big && 'I am a chart in a big container',
                cardComponent.displayName),
            react_1.default.createElement(typography_1.default, { variant: "caption", className: "description" }, cardComponent.description))));
};
exports.default = LineChart;
//# sourceMappingURL=line-chart.js.map